<template>
  <div>
    <div class="input-group">
      <div class="input-group-prepend">
        <span
          class="input-group-text"
          style="font-size:0.75rem !important;padding-left:.3rem;padding-right:.3rem"
          >Rp</span
        >
      </div>

      <input
        type="number"
        money="true"
        :class="'form-control ' + input.class"
        :value="value"
        @change="(e) => handleChange(e)"
        @blur="(e) => handleBlur(e)"
        :placeholder="input.placeholder"
        :required="!input.optional"
        :disabled="input.disabled"
        :name="input.name"
        :readonly="input.readonly"
      />
    </div>
    <!-- <h3 class="masked-money mb-0 mt-1">Rp {{input.value}}</h3> -->
  </div>
</template>
<style scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
<script>
export default {
  name: "InputMoney",
  components: {},
  props: {
    input: Object,
    value: [String, Number],
  },
  data: function() {
    return {};
  },
  methods: {
    handleChange(e) {
      this.$emit("handleChange", e);
    },
    handleBlur(e) {
      this.$emit("handleBlur", e);
    },
  },
};
</script>
